const d =
	'M140-166q-39.05 0-66.525-27.975Q46-221.95 46-260v-440q0-39.463 27.475-67.231Q100.95-795 140-795h680q39.463 0 67.231 27.769Q915-739.463 915-700v440q0 38.05-27.769 66.025Q859.463-166 820-166H140Zm160-159h360v-60H300v60Zm-97-125h60v-60h-60v60Zm124 0h60v-60h-60v60Zm123 0h60v-60h-60v60Zm124 0h60v-60h-60v60Zm123 0h60v-60h-60v60ZM203-575h60v-60h-60v60Zm124 0h60v-60h-60v60Zm123 0h60v-60h-60v60Zm124 0h60v-60h-60v60Zm123 0h60v-60h-60v60Z';

export default d;
